import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function DraftIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 33 33" htmlColor={Color.Body} {...props}>
      <path d="M8.86 29.391a2.33 2.33 0 0 1-1.71-.7 2.33 2.33 0 0 1-.7-1.71V6.468q0-1.01.7-1.71a2.33 2.33 0 0 1 1.71-.7h9.593q.482 0 .927.187.444.187.773.516l5.595 5.594a2.42 2.42 0 0 1 .702 1.7v14.926q0 1.01-.7 1.71t-1.71.7zm9.59-18.538q0 .515.345.86t.86.345h4.795l-6-6z" />
    </MuiSvgIcon>
  );
}
export default DraftIcon;
